import * as config from '@/config.json'

import Loading from 'vue-loading-overlay'
import axios from 'axios'

export default {
  name: 'UsersManager',
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      userId: null,
      name: '',
      phone: '',
      email: '',
      password: '',
      passwordConfirmed: '',
      state: null,
      redirectUser: '',
      selectedOptionUser: null,
      optionsUser: [
        {
          text: 'Organização',
          value: '1'
        },
        {
          text: 'Empresa',
          value: '2'
        },
        {
          text: 'Loja',
          value: '3'
        }
      ],
      division: null,
      organizationDivision: null,
      companiesByUserType: '',
      sitesByUserType: '',
      token: null,
      selected: [],
      companies: [],
      selectedOptionCompany: null,
      typeUser: '',
      paramsUserPermission: {},
      isTelegramNotify: false,
      isAppNotify: false,
      originatingSearch: false,
      inactive: false,
      telegramChatId: '',
      telegramToken: ''
    }
  },

  methods: {
    generateTokenSegment() {
      const n = Math.floor(Math.random() * 10000)
      return String(n).padStart(4, '0')
    },

    generateNonRepeatingToken() {
      const parts = []
      for (let i = 0; i < 5; i++) {
        parts.push(this.generateTokenSegment())
      }
      return `${parts[0]}-${parts[1]}-${parts[2]}-${parts[3]}-${parts[4]}`
    },
    verifyState() {
      // Se estiver no modo perfil, validar apenas campos essenciais
      if (this.originatingSearch === true) {
        return this.name != '' && this.selectedOptionUser != null && this.selectedOptionCompany != null
      } else {
        // Modo de criação - validar todos os campos incluindo senha
        return (
          this.name != '' &&
          this.phone != '' &&
          this.password != '' &&
          this.passwordConfirmed != '' &&
          this.email != '' &&
          this.selectedOptionUser != null &&
          this.selectedOptionCompany != null
        )
      }
    },

    redirect() {
      // Se estiver no modo perfil, redirecionar para home
      if (this.isProfileMode) {
        this.$router.push('/home')
        return
      }

      // Se estiver editando usuário da lista, verificar o redirectUser no localStorage
      const ref = localStorage.getItem('redirectUser') ? localStorage.getItem('redirectUser') : 'home'
      localStorage.removeItem('redirectUser')
      this.$router.push(ref)
    },

    async filterOptionUser(typeUser) {
      const typeOrganization = 'organization'

      if (typeUser !== typeOrganization) {
        this.optionsUser = this.optionsUser.filter(option => option.value !== '1')
      }
    },

    focus(id) {
      const el = document.getElementById(id)
      if (!el) return
      if (id === 'phone') {
        const input = el.querySelector('input') || this.$refs.phoneInput?.$el?.querySelector('input')
        if (input) {
          input.focus()
          return
        }
      }
      el.focus()
    },

    async onSelected(userDivisionSelected) {
      if (userDivisionSelected == 1) {
        this.organizationDivision = sessionStorage.getItem('divisionId') + ' ' + sessionStorage.getItem('divisionName')
        this.selectedOptionCompany = sessionStorage.getItem('divisionId')
      } else if (userDivisionSelected == 2) {
        this.companiesByUserType = await this.getCompaniesByUserType()
      } else {
        this.sitesByUserType = await this.getSitesByUserType()
      }
    },

    async getCompaniesByUserType() {
      this.isLoading = true

      const url = `${config.default.urlBase}/companies/user/type`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          this.companies = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.companies.length == 1) {
            this.selectedOptionCompany = this.companies[0].value
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSitesByUserType() {
      this.isLoading = true

      const url = `${config.default.urlBase}/sites/user/type`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          this.companies = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.companies.length == 1) {
            this.selectedOptionCompany = this.companies[0].value
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    verifyPassword(newPassword, confirmedPassword) {
      return newPassword == confirmedPassword ? true : false
    },

    showPassword(id) {
      let password = document.getElementById(id)

      const type = password.type == 'password' ? 'text' : 'password'
      password.type = type

      if (id == 'password') {
        this.focus('password')
      } else {
        this.focus('passwordConfirmed')
      }
    },

    onPhoneInput(value) {
      // Validar e filtrar apenas números e caracteres válidos para telefone
      if (value) {
        // Permitir apenas números, +, -, (, ), espaços e caracteres de formatação válidos
        const validPhoneRegex = /^[+\d\s\-()]+$/

        if (!validPhoneRegex.test(value)) {
          // Se contém caracteres inválidos, reverter para o valor anterior
          this.$nextTick(() => {
            this.phone = this.phone.replace(/[^+\d\s\-()]/g, '')
          })
          return
        }

        // Remover caracteres especiais inválidos e manter apenas números e formatação básica
        const cleanedValue = value.replace(/[^+\d\s\-()]/g, '')
        this.phone = cleanedValue
      } else {
        this.phone = value
      }
    },

    async buildUser(
      userId,
      name,
      phone,
      email,
      password,
      type,
      divisionId,
      isTelegramNotify,
      isAppNotify,
      originatingSearch,
      inactive,
      telegramChatId,
      telegramToken
    ) {
      const user = {
        name: name ? name.trim() : '',
        phone: phone ? phone.trim() : '',
        email: email ? email.trim() : ''
      }

      // Adicionar type sempre que for válido (campo obrigatório)
      if (type && !isNaN(parseInt(type))) {
        user.type = parseInt(type)
      }

      // Adicionar divisionId sempre que for válido (campo obrigatório)
      if (divisionId && !isNaN(parseInt(divisionId))) {
        user.divisionId = parseInt(divisionId)
      }

      // Adicionar campos de notificação para todos os usuários Telegram
      user.isTelegramNotify = Boolean(isTelegramNotify)
      user.isAppNotify = Boolean(isAppNotify)
      if (user.isTelegramNotify) {
        user.telegramChatId = telegramChatId != null ? String(telegramChatId) : ''
        user.telegramToken = telegramToken != null ? String(telegramToken) : ''
      }

      if (originatingSearch == false) {
        // Adicionar password apenas se for válido para novos usuários
        if (password && password.trim()) {
          user.password = password.trim()
        }
      } else {
        user.id = parseInt(userId)
        user.inactive = inactive
      }

      return {
        user
      }
    },

    async readUserParams() {
      // Verificar se está no modo de edição do perfil
      const editUserMode = localStorage.getItem('editUserMode')

      if (editUserMode === 'profile') {
        // Carregar dados do usuário logado para edição
        this.userId = localStorage.getItem('editUserId') ? parseInt(localStorage.getItem('editUserId')) : null
        this.name = localStorage.getItem('editUserName') || ''

        // Carregar dados adicionais
        this.email = localStorage.getItem('editUserEmail') || sessionStorage.getItem('userEmail') || ''

        // Formatar telefone para o vue-tel-input (adicionar +55 se não tiver)
        const rawPhone = localStorage.getItem('editUserPhone') || sessionStorage.getItem('userPhone') || ''
        if (rawPhone && !rawPhone.startsWith('+')) {
          this.phone = `+55${rawPhone}`
        } else {
          this.phone = rawPhone
        }

        // Carregar notificações do localStorage primeiro, depois do sessionStorage como fallback
        const telegramNotify = localStorage.getItem('editUserTelegramNotify') || sessionStorage.getItem('userIsTelegramNotify')
        this.isTelegramNotify = telegramNotify === '1' || telegramNotify === 'true' || telegramNotify === true

        const appNotify = localStorage.getItem('editUserAppNotify') || sessionStorage.getItem('userIsAppNotify')
        this.isAppNotify = appNotify === '1' || appNotify === 'true' || appNotify === true

        // Carregar campos adicionais se disponíveis
        this.telegramChatId = localStorage.getItem('editUserTelegramChatId') || ''
        this.telegramToken = localStorage.getItem('editUserTelegramToken') || ''

        // Mapear o tipo de usuário para o valor correto
        const userType = localStorage.getItem('editUserType')

        if (userType === 'organization') {
          this.selectedOptionUser = '1'
        } else if (userType === 'company') {
          this.selectedOptionUser = '2'
        } else if (userType === 'store') {
          this.selectedOptionUser = '3'
        } else {
          // Fallback para valores numéricos
          this.selectedOptionUser = userType
        }

        this.selectedOptionCompany = localStorage.getItem('editDivisionId') || null

        // Marcar como modo de edição
        this.originatingSearch = true

        // Carregar dados relacionados
        if (this.selectedOptionUser) {
          await this.onSelected(this.selectedOptionUser)
        }

        // Configurar organização explicitamente se for tipo 1 (organização)
        if (this.selectedOptionUser === '1') {
          this.organizationDivision = sessionStorage.getItem('divisionId') + ' ' + sessionStorage.getItem('divisionName')
        }

        // NÃO limpar o localStorage aqui - será limpo apenas após atualização bem-sucedida
        // para permitir que o usuário possa tentar novamente se houver erro
      } else {
        // Modo normal - ler parâmetros da rota
        this.userId = this.$route.params.userId ? parseInt(this.$route.params.userId) : null
        this.name = this.$route.params.name ? this.$route.params.name : ''
        // Normalizar telefone para o vue-tel-input (usar +55 se não vier com código)
        if (this.$route.params.phone) {
          const routePhone = this.$route.params.phone
          this.phone = routePhone.startsWith('+') ? routePhone : `+55${routePhone}`
        } else {
          this.phone = ''
        }
        this.email = this.$route.params.email ? this.$route.params.email : ''
        this.selectedOptionUser = this.$route.params.type ? this.$route.params.type : null

        await this.onSelected(this.selectedOptionUser)

        this.selectedOptionCompany = this.$route.params.divisionId ? this.$route.params.divisionId : null
        this.isAppNotify = this.$route.params.isAppNotify ? this.$route.params.isAppNotify : false
        this.isTelegramNotify = this.$route.params.isTelegramNotify ? this.$route.params.isTelegramNotify : false
        this.originatingSearch = this.$route.params.originatingSearch ? this.$route.params.originatingSearch : false
        this.inactive = this.$route.params.inactive ? this.$route.params.inactive : false
      }
    },

    async CreateOrUpdate() {
      if (this.originatingSearch == false) {
        await this.createUser()
      } else {
        await this.updateUser()
      }
    },

    async createUser() {
      this.isLoading = true

      if (this.password && this.passwordConfirmed) {
        const passwordVerified = this.verifyPassword(this.password, this.passwordConfirmed)

        if (!passwordVerified) {
          this.isLoading = false
          await this.$alert('As senhas digitadas não conferem!', 'Error', 'error')
          return
        }
      }

      const url = `${config.default.urlBase}/users`

      if (this.isTelegramNotify) {
        if (!this.telegramToken || this.telegramToken.trim() === '') {
          this.telegramToken = this.generateNonRepeatingToken()
        }
      } else {
        this.telegramToken = ''
        this.telegramChatId = ''
      }
      const builtUser = await this.buildUser(
        this.userId,
        this.name,
        this.phone,
        this.email,
        this.password,
        this.selectedOptionUser,
        this.selectedOptionCompany,
        this.isTelegramNotify,
        this.isAppNotify,
        this.originatingSearch,
        this.inactive,
        this.telegramChatId,
        this.telegramToken
      )

      try {
        const response = await axios({
          url,
          method: 'post',
          data: builtUser,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200 || response.status == 201) {
          this.isLoading = false

          const res = await this.$swal({
            title: 'Sucesso',
            text: `Usuário cadastrado! Deseja cadastrar as permissões do usuário?`,
            icon: 'success',
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: '#303030',
            cancelButtonColor: '#fe5c3a',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
          })

          if (res.isConfirmed) {
            localStorage.removeItem('redirectUserPermissions')
            localStorage.setItem('redirectUserPermissions', 'users-manager')
            this.paramsUserPermission = {
              userId: response.data.user.id,
              userName: response.data.user.name,
              page: 'usersManager'
            }

            this.$router.push({
              name: 'ManagerUserPermissions',
              params: this.paramsUserPermission
            })
          } else {
            this.redirect()
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          this.isLoading = false
          await this.$alert(`Falha ao cadastrar o usuário! ${error.response.data.message}`, 'Error', 'error')
        }
      }
    },

    async updateUser() {
      this.isLoading = true

      const url = `${config.default.urlBase}/users`

      if (this.isTelegramNotify) {
        if (!this.telegramToken || this.telegramToken.trim() === '') {
          this.telegramToken = this.generateNonRepeatingToken()
        }
      } else {
        this.telegramToken = ''
        this.telegramChatId = ''
      }
      const builtUser = await this.buildUser(
        this.userId,
        this.name,
        this.phone,
        this.email,
        this.password,
        this.selectedOptionUser,
        this.selectedOptionCompany,
        this.isTelegramNotify,
        this.isAppNotify,
        this.originatingSearch,
        this.inactive,
        this.telegramChatId,
        this.telegramToken
      )

      console.log({
        builtUser
      })

      try {
        const response = await axios({
          url,
          method: 'put',
          data: builtUser,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200 || response.status == 201) {
          this.isLoading = false

          // Atualizar sessionStorage com os novos dados se estiver no modo perfil
          if (this.isProfileMode) {
            this.updateSessionStorageAfterProfileUpdate()
            await this.$alert('Perfil atualizado com sucesso!', 'Sucesso', 'success')
          } else {
            await this.$alert('Usuário Atualizado!', 'Sucesso', 'success')
          }

          // Usar o método redirect() para navegação consistente
          this.redirect()
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          this.isLoading = false
          await this.$alert(`Falha ao atualizar o usuário! ${error.response.data.message}`, 'Error', 'error')
        }
      }
    },

    updateSessionStorageAfterProfileUpdate() {
      // Atualizar sessionStorage com os novos dados
      sessionStorage.setItem('usuarioLogado', this.name)
      sessionStorage.setItem('userEmail', this.email)
      sessionStorage.setItem('userPhone', this.phone)
      sessionStorage.setItem('userIsTelegramNotify', this.isTelegramNotify)
      sessionStorage.setItem('userIsAppNotify', this.isAppNotify)
      sessionStorage.setItem('userTelegramChatId', this.telegramChatId)
      sessionStorage.setItem('userTelegramToken', this.telegramToken)

      // Limpar localStorage após atualização bem-sucedida
      this.clearEditUserLocalStorage()
    },

    clearEditUserLocalStorage() {
      localStorage.removeItem('editUserId')
      localStorage.removeItem('editUserName')
      localStorage.removeItem('editUserType')
      localStorage.removeItem('editDivisionId')
      localStorage.removeItem('editDivisionName')
      localStorage.removeItem('editUserMode')
      localStorage.removeItem('editUserEmail')
      localStorage.removeItem('editUserPhone')
      localStorage.removeItem('editUserTelegramNotify')
      localStorage.removeItem('editUserAppNotify')
      localStorage.removeItem('editUserTelegramChatId')
      localStorage.removeItem('editUserTelegramToken')
    }
  },

  async updated() {
    this.state = await this.verifyState()
  },

  computed: {
    isProfileMode() {
      // Verificar se está no modo perfil (editUserMode === 'profile' no localStorage)
      const editUserMode = localStorage.getItem('editUserMode')
      return editUserMode === 'profile' && this.originatingSearch && parseInt(this.userId) === parseInt(sessionStorage.getItem('idUsuarioLogado'))
    },
    nameState() {
      return this.name ? true : false
    },
    phoneState() {
      // Considerar válido se tiver pelo menos o código do país +55 e apenas caracteres válidos
      if (!this.phone || this.phone.length < 3) {
        return false
      }

      // Verificar se contém apenas caracteres válidos para telefone
      const validPhoneRegex = /^[+\d\s\-()]+$/
      return validPhoneRegex.test(this.phone)
    },
    passwordState() {
      return this.password ? true : false
    },
    passwordConfirmedState() {
      return this.passwordConfirmed ? true : false
    },
    emailState() {
      return this.email ? true : false
    },
    typeUserState() {
      return this.selectedOptionUser ? true : false
    },
    divisionState() {
      return this.selectedOptionCompany || this.organizationDivision ? true : false
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')

    // Aguardar a leitura dos parâmetros do usuário
    await this.readUserParams()

    this.state = this.verifyState()

    this.typeUser = sessionStorage.getItem('typeUser')
    await this.filterOptionUser(this.typeUser)

    this.isLoading = false
  }
}
